import { EmailTemplateLocaleFields, EmailTemplateRecord } from 'src/stores/emailTemplatesStore';

const EDITOR_TEXT_FIELDS: (keyof EmailTemplateLocaleFields)[] = [
  'greeting',
  'intro',
  'actionInstructions',
  'rejectInstructions',
  'outro',
  'signature',
  'outroHtml',
];

export function htmlBrToNewlines(text: string): string {
  return text.replace(/<br\s*\/?>/gi, '\n');
}

function normalizeLocaleForEditor(locale: EmailTemplateLocaleFields): EmailTemplateLocaleFields {
  const next = { ...locale };
  for (const field of EDITOR_TEXT_FIELDS) {
    if (next[field]) {
      next[field] = htmlBrToNewlines(next[field]);
    }
  }
  return next;
}

function normalizeTransferLocale(locale: EmailTemplateLocaleFields): EmailTemplateLocaleFields {
  return {
    ...normalizeLocaleForEditor(locale),
    outroHtml: '',
  };
}

export function normalizeTemplateForEditor(record: EmailTemplateRecord): EmailTemplateRecord {
  const normalizeLocale =
    record.key === 'participants.transfer' ? normalizeTransferLocale : normalizeLocaleForEditor;

  return {
    ...record,
    locales: {
      en: normalizeLocale(record.locales.en),
      hu: normalizeLocale(record.locales.hu),
      ro: normalizeLocale(record.locales.ro),
    },
  };
}

export function normalizeTemplateForStorage(record: EmailTemplateRecord): EmailTemplateRecord {
  return normalizeTemplateForEditor(record);
}
